// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"az_rQb","xLargeOverride":"az_sQb"};